import React, { MouseEvent, useState, useEffect, useRef } from 'react';
import { formatMoneda } from '../../util/varios';
import axios from "axios";
import { Mensaje } from '../mensajes';
import useTableScroll from '../useTableScroll';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import { Dimmer, Loader } from 'semantic-ui-react';
import useTable from '../useTable';


function ClassVacios(props) {
    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCION', textAlign: 'center' },
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [valor, setValor] = useState([]);
    const [valoru, setValoru] = useState([]);
    const [totaLClientes, setTotalClientes] = useState()
    const [total, setTotal] = useState(0.00);
    const [mostrar, setMostrar] = useState(false);
    const [totalu, setTotalu] = useState(0.00);
    const [idnot, setIdnot] = useState(0)
    const [menor, setMenor] = useState(0.00);
    const [abono, setAbono] = useState(0.0);
    const [colorF, setColorF] = useState([])
    const color = [];
    const [datos, setDatos] = useState([{
        color: '#0d6efd',
        nombre: 'Total Cobrado',
        valor: '545.555,23'
    }, {
        color: '#dc3545',
        nombre: 'Total x Cobrar',
        valor: '54.445,42'
    }
    ]);
    const txtBuscar = useRef();
    const [records, setRecords] = useState([]);
    const [municipiosData, setMunicipiosData] = useState([]);
    const [colorG, setColorG] = useState([
        '#0d6efd',
        '#dc3545'


    ]);
    const [rm, setRM] = useState({
        enero: 0.00,
        febrero: 0.00,
        marzo: 0.00,
        abril: 0.00,
        mayo: 0.00,
        junio: 0.00,
        julio: 0.00,
        agosto: 0.00,
        septiembre: 0.00,
        octubre: 0.00,
        noviembre: 0.00,
        diciembre: 0.00
    });
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(JSON.parse(sessionStorage.getItem('fechasistema')));
    const [anioActu, setAnioActu] = useState(sessionStorage.getItem('anioactu'));
    const [label, setLabel] = useState([]);
    const [labelu, setLabelu] = useState([]);

    const [data, setData] = useState();

    const [options, setOptions] = useState();
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            x.idclasevacio.includes(target.value) ||
                            x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };



    let token = sessionStorage.getItem('jwtToken');
    let op = require('../../../public/modulos/datos');
    const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
    const accbtncntxpagarc = JSON.parse(
        sessionStorage.getItem("accbtncntxpagarc")
    );
    const txtMesPetro = useRef();
    const txtMesUTE = useRef();


    const blanquear = () => {
        setIdnot(0);

    }

    const seleccionarRegistros = () => {
        let campos = "*";
        let nomtab = "clasevacio";
        let orden = "idclasevacio";

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                        txtBuscar.current.focus();
                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    /* const onGestionar = (item) => (e) => {
        if (ncaja !== "") {
            if (
                accbtncntxpagarc &&
                accbtncntxpagarc.toString().substring(0, 1) === "1"
            ) {

                setIdnot(item.idfactura);
                setAbono(item.abono);
                setMostrar(true);

            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else {
            setMensaje({
                mostrar: true,
                titulo: "Notificación.",
                texto: "¡No Posee un Número de Caja Asignada!",
                icono: "error",
            });
        }
    }; */

    return (
        <div className='col-md-12 mx-auto'>
            <div className='col-md-12 mt-2'>
                <div>
                    <Mensaje mensaje={mensaje}
                        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                    <div className="container-fluid px-3 py-2">
                        <div className="row col-md-10 card py-3 mx-auto">
                            <div className="row col-md-12 mx-auto">

                                <div className='col-md-12 row h-100'>
                                    <div className='col-md-12 row mx-auto py-3 m-0'>
                                        <div className="row col-md-12 m-0 px-0">
                                            <div className="input-group col-md-6 input-group-sm px-0">
                                                <input
                                                    type="text"
                                                    onChange={handleSearch}
                                                    placeholder="Buscar"
                                                    title="Buscar Clasificador de Vacios"
                                                    className="form-control text-uppercase"
                                                    ref={txtBuscar}
                                                />
                                                <button
                                                    className="btn"
                                                    style={{
                                                        pointerEvents: "none",
                                                        backgroundColor: "rgba(5, 81, 130, 1)",
                                                        color: "#FFFFFF",
                                                    }}
                                                >
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-md-12 mt-2 px-0 mx-0 rounded'>
                                            <TblContainer container={{ height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' }} >
                                                <TblHead />
                                                <TableBody className='overflow-hidden table-bordered' >
                                                    {
                                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                                            <TableRow key={index} style={{ padding: "0" }}>
                                                                <TableCell className='align-baseBar bg-light' style={{ textAlign: "center", width: '50px' }} >{item.idclasevacio}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ width: '400px' }} >{item.descripcion}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </TblContainer>
                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dimmer active={activate} inverted>
                <Loader inverted>cargando...</Loader>
            </Dimmer>
        </div>
    );

}

export default ClassVacios;


// WEBPACK FOOTER //
// ./src/components/vacios/tablaClassVacios.js